import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface WeightOption {
  label: string;
  value: number;
  description: string;
}

@Component({
  selector: 'app-weight-selector',
  templateUrl: './weight-selector.component.html',
  styleUrls: ['./weight-selector.component.scss'],
  standalone: false
})
export class WeightSelectorComponent {
  @Input() selectedWeight: number | null = null;
  @Input() disabled = false;
  @Output() weightChange = new EventEmitter<number>();

  showLearnMore = false;

  weightOptions: WeightOption[] = [
    {
      label: 'Low',
      value: 2,
      description: 'Monitor this item with lower scoring influence. Use when diversion concern exists but routine clinical use is common.'
    },
    {
      label: 'Medium',
      value: 5,
      description: 'Moderate influence on risk scoring. Use when diversion concern is meaningful and should critically affect prioritization.'
    },
    {
      label: 'High',
      value: 8,
      description: 'Strong influence on risk scoring. Use when diversion concern is high and activity should substantially impact review priority.'
    }
  ];

  get isHighSelected(): boolean {
    return this.selectedWeight === 8;
  }

  selectWeight(value: number): void {
    if (this.disabled) return;
    this.selectedWeight = value;
    this.weightChange.emit(value);
  }

  toggleLearnMore(): void {
    this.showLearnMore = !this.showLearnMore;
  }
}
